import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Button } from '@material-ui/core';

class OverwriteDialog extends Component {

    checkDisabled = (oldLesson, newLesson) => {
        if ( oldLesson.eventType === 'existingEventModule' && newLesson.eventType === 'existingEventModule' ) {
            if ( oldLesson.company_calendar_module_id === newLesson.company_calendar_module_id ) {
                return true
            }
        }
        if ( oldLesson.eventType === 'existingEventCourse' && newLesson.eventType === 'existingEventCourse' ) {
            if ( oldLesson.company_calendar_course_id === newLesson.company_calendar_course_id ) {
                return true
            }
        }
        return false
    }

    render() {
        const { classes, oldLesson, newLesson } = this.props
        
        const disableText = this.checkDisabled(newLesson, oldLesson) ? '*You cannot have multiple lessons from the same component on one day' : null
        return (
            <Dialog
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Multiple Lessons on Schedule {this.props.date}</DialogTitle>
                <DialogContent>
                <span>{disableText}</span>
                    <Grid container spacing={24}>
                        
                        <Grid item xs={6}><b>New: </b>{newLesson.title}

                        </Grid>
                        <Grid item xs={6}><b>Old: </b>{oldLesson.title}

                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState('drop', newLesson, oldLesson, this.props.date)}
                                disabled={this.checkDisabled(oldLesson, newLesson)}
                            >Drop
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState('replace', newLesson, oldLesson, null)}
                            >Overwrite
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState('swap', newLesson, oldLesson, null)}
                            >Swap
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState('goBack', oldLesson, newLesson, null)}
                            >Go Back
                            </Button>
                        </Grid>
                    </Grid>

                </DialogContent>
            </Dialog>
        )
    }
}

export default OverwriteDialog;


// WEBPACK FOOTER //
// src/main/content/company/CompanyCalendar/OverwriteDialog.js